import { useEffect } from "react";
import { useSelector } from "react-redux";

import { config } from "config/config";
import { isDesktopApp } from "helpers/is-desktop-app";
import { redirect } from "helpers/routing";
import { selectIsGhostLogin } from "store/features/session";

import { useBreakpoints } from "./use-breakpoints";
import { useHasTextApp } from "./use-has-text-app";

export function useRedirectToTextApp(pathname: string): { isFetching: boolean; isRedirecting: boolean } {
  const textApp = useHasTextApp();
  const isFetching = textApp === undefined;
  const isRedirecting = useShouldRedirectToTextApp();

  useEffect(() => {
    if (isRedirecting === true) {
      redirect(`${config.textAppHost}${pathname}`);
    }
  }, [isRedirecting, pathname]);

  return { isFetching, isRedirecting };
}

export function useShouldRedirectToTextApp(): boolean {
  const isGhostLogin = useSelector(selectIsGhostLogin);
  const textApp = useHasTextApp();
  const desktopApp = isDesktopApp();
  const { isMobile } = useBreakpoints();

  return textApp === true && desktopApp === false && isMobile === false && !isGhostLogin;
}
